import {
    Alert,
    Box,
    Button,
    Dialog,
    DialogActions, DialogContent, DialogContentText,
    DialogTitle, Divider,
    FormControl,
    Grid, Stack,
    TextField,
    Typography
} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import {useParams} from "react-router-dom";
import {getI18nContent} from "../../config/i18nConfig";
import {useEffect, useState} from "react";
import {FlexBox} from "../Theme/CustomComponent";
import dayjs, {unix} from "dayjs";
import {PARTNER_URI} from "../../Utils/apiUrl";
import axios from "axios";
import {MuiTelInput} from "mui-tel-input";
import {getMissingKeysFromObject, isValidatePhone} from "../../Utils/Helper";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

export const WordPressToolsConsigneeDetails = ({
                                                   consigneeData,
                                                   bolNumber,
                                                   oneTimeCode,
                                                   getLTLConsigneeDetailsByConfirmationCodeAndBOLNumber
                                               }) => {

    const theme = useTheme();

    const {lng} = useParams();

    const uiText = getI18nContent(lng, 'LTLTools');

    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [consigneeDetails, setConsigneeDetails] = useState({
        appointmentDeliverDate: "",
        deliverLocationOpenTime: "",
        deliverLocationCloseTime: "",
        appointmentDeliverName: "",
        appointmentDeliverPhone: ""
    });
    const [originalConsigneeDetails, setOriginalConsigneeDetails] = useState({
        appointmentDeliverDate: "",
        deliverLocationOpenTime: "",
        deliverLocationCloseTime: "",
        appointmentDeliverName: "",
        appointmentDeliverPhone: ""
    });
    const [validatedResult, setValidatedResult] = useState(null);
    const [updateDialog, setUpdateDialog] = useState(false);

    const handleOpenDialog = () => {
        setUpdateDialog(true);
    }

    const handleCloseDialog = () => {
        setUpdateDialog(false);
    }

    const handleAppointmentDeliverDate = (event) => {
        let {value} = event.target;
        const today = dayjs().format('YYYY-MM-DD');

        if (!value || value < today) {
            value = today;
        }

        setConsigneeDetails(prevState => ({
            ...prevState,
            appointmentDeliverDate: value,
        }))
    }

    const handleDeliverLocationOpenTime = (event) => {
        let {value} = event.target;

        if (value < "07:00") {
            value = "07:00";
        } else if (value > "19:00") {
            value = "19:00";
        }

        setConsigneeDetails(prevState => ({
            ...prevState,
            deliverLocationOpenTime: value,
        }))
    }

    const handleDeliverLocationCloseTime = (event) => {
        let {value} = event.target;

        if (value < "07:00") {
            value = "07:00";
        } else if (value > "19:00") {
            value = "19:00";
        }

        setConsigneeDetails(prevState => ({
            ...prevState,
            deliverLocationCloseTime: value,
        }))
    }

    const handleAppointmentDeliverName = (event) => {
        const {value} = event.target;
        setConsigneeDetails(prevState => ({
            ...prevState,
            appointmentDeliverName: value,
        }))
    }

    const handleAppointmentDeliverPhone = (value) => {
        setConsigneeDetails(prevState => ({
            ...prevState,
            appointmentDeliverPhone: value,
        }))
    }

    const editLTLConsigneeDetailsByConfirmationCodeAndBOLNumber = async () => {
        try {
            setLoading(true);
            setSuccessMessage('');
            setErrorMessage('');

            const requestURL = `${PARTNER_URI}/shippingLTL/editLTLConsigneeDetailsByConfirmationCodeAndBOLNumber`;

            const data = {
                bolNumber: bolNumber,
                confirmationCode: oneTimeCode,
                ...consigneeDetails
            }

            const result = await axios({
                method: 'post',
                url: requestURL,
                data: data
            });

            setErrorMessage('');
            setSuccessMessage(uiText.consignee.successMessage);
            setTimeout(() => getLTLConsigneeDetailsByConfirmationCodeAndBOLNumber(), 3000);
        } catch (e) {

            setSuccessMessage('');
            setErrorMessage(uiText.consignee.errorMessage);

        } finally {
            setLoading(false);
            handleCloseDialog();
        }
    }

    const validate = async () => {
        const missingValues = getMissingKeysFromObject({
            ...consigneeDetails
        });

        const phoneCheck = isValidatePhone(consigneeDetails?.appointmentDeliverPhone);

        return !(missingValues?.length > 0 ||
            !phoneCheck);
    }

    const handleUpdate = async () => {
        const validation = await validate();
        setValidatedResult(validation);
        if (validation) {
            handleOpenDialog();
        }
    }


    useEffect(() => {
        if (consigneeData) {
            setConsigneeDetails(prevState => ({
                ...prevState,
                appointmentDeliverDate: consigneeData?.appointment_deliver_date,
                deliverLocationOpenTime: dayjs(`${consigneeData?.appointment_deliver_date} ${consigneeData?.deliver_location_open_time}`).format('HH:mm'),
                deliverLocationCloseTime: dayjs(`${consigneeData?.appointment_deliver_date} ${consigneeData?.deliver_location_close_time}`).format('HH:mm'),
                appointmentDeliverName: consigneeData?.consignee_name,
                appointmentDeliverPhone: consigneeData?.consignee_phone
            }));
            setOriginalConsigneeDetails(prevState => ({
                ...prevState,
                appointmentDeliverDate: consigneeData?.appointment_deliver_date,
                deliverLocationOpenTime: dayjs(`${consigneeData?.appointment_deliver_date} ${consigneeData?.deliver_location_open_time}`).format('HH:mm'),
                deliverLocationCloseTime: dayjs(`${consigneeData?.appointment_deliver_date} ${consigneeData?.deliver_location_close_time}`).format('HH:mm'),
                appointmentDeliverName: consigneeData?.consignee_name,
                appointmentDeliverPhone: consigneeData?.consignee_phone
            }));
        }

    }, [consigneeData]);

    console.log('[WordPressToolsConsigneeDetails] consigneeDetails', consigneeDetails);
    console.log('[WordPressToolsConsigneeDetails] originalConsigneeDetails', originalConsigneeDetails);

    return (
        <Grid container spacing={2}>
            <Dialog
                open={updateDialog}
                onClose={handleCloseDialog}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle sx={{pb: 1}}>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <WarningAmberIcon color="warning"/>
                        <Box>
                            <Typography variant="subtitle1">
                                {uiText.consignee.feeDialog.title}
                            </Typography>
                        </Box>
                    </Stack>
                </DialogTitle>

                <DialogContent dividers>
                    <DialogContentText sx={{mb: 2, color: 'text.primary'}}>
                        <Typography variant='body2'>{uiText.consignee.feeDialog.content}</Typography>
                        <Typography variant="caption">{uiText.consignee.feeDialog.subContent}</Typography>
                    </DialogContentText>
                </DialogContent>

                <DialogActions sx={{p: 2, justifyContent: 'space-between'}}>
                    <Button onClick={handleCloseDialog}>
                        {uiText.consignee.feeDialog.cancel}
                    </Button>
                    <Button
                        onClick={editLTLConsigneeDetailsByConfirmationCodeAndBOLNumber}
                        variant="contained"
                        color="primary"
                        autoFocus
                        loading={loading}
                    >
                        {uiText.consignee.feeDialog.confirm}
                    </Button>
                </DialogActions>
            </Dialog>
            <Grid size={{xs: 12}}>
                {successMessage && (
                    <Alert
                        severity="success"
                        onClose={() => setSuccessMessage('')}
                        sx={{mb: 1}}
                    >
                        {successMessage}
                    </Alert>
                )}
                {errorMessage && (
                    <Alert
                        severity="error"
                        onClose={() => setErrorMessage('')}
                        sx={{mb: 1}}
                    >
                        {errorMessage}
                    </Alert>
                )}
            </Grid>
            <Grid size={{xs: 12}}>
                <Typography variant='body2' sx={{
                    fontWeight: theme.typography.h1.fontWeight
                }}>
                    {uiText.consignee.heading}
                </Typography>
            </Grid>
            <Grid size={{xs: 4}}>
                <TextField
                    fullWidth
                    label={uiText.consignee.consigneeName}
                    value={consigneeData?.consignee_name || "N/A"}
                    size="small"
                    slotProps={{
                        input: {readOnly: true},
                        inputLabel: {sx: {...theme.typography.caption}},
                        htmlInput: {sx: {...theme.typography.caption, bgcolor: theme.palette.neutral[100]}}
                    }}
                />
            </Grid>
            <Grid size={{xs: 4}}>
                <TextField
                    fullWidth
                    label={uiText.consignee.companyName}
                    value={consigneeData?.consignee_company_name || "N/A"}
                    size="small"
                    slotProps={{
                        input: {readOnly: true},
                        inputLabel: {sx: {...theme.typography.caption}},
                        htmlInput: {sx: {...theme.typography.caption, bgcolor: theme.palette.neutral[100]}}
                    }}
                />
            </Grid>
            <Grid size={{xs: 4}}>
                <TextField
                    fullWidth
                    label={uiText.consignee.phone}
                    value={consigneeData?.consignee_phone || "N/A"}
                    size="small"
                    slotProps={{
                        input: {readOnly: true},
                        inputLabel: {sx: {...theme.typography.caption}},
                        htmlInput: {sx: {...theme.typography.caption, bgcolor: theme.palette.neutral[100]}}
                    }}
                />
            </Grid>
            <Grid size={{xs: 4}}>
                <TextField
                    fullWidth
                    label={uiText.consignee.email}
                    value={consigneeData?.consignee_email || "N/A"}
                    size="small"
                    slotProps={{
                        input: {readOnly: true},
                        inputLabel: {sx: {...theme.typography.caption}},
                        htmlInput: {sx: {...theme.typography.caption, bgcolor: theme.palette.neutral[100]}}
                    }}
                />
            </Grid>
            <Grid size={{xs: 4}}>
                <TextField
                    fullWidth
                    label={uiText.consignee.address}
                    value={consigneeData?.consignee_address || "N/A"}
                    size="small"
                    slotProps={{
                        input: {readOnly: true},
                        inputLabel: {sx: {...theme.typography.caption}},
                        htmlInput: {sx: {...theme.typography.caption, bgcolor: theme.palette.neutral[100]}}
                    }}
                />
            </Grid>
            <Grid size={{xs: 4}}>
                <TextField
                    fullWidth
                    label={uiText.consignee.city}
                    value={consigneeData?.consignee_city || "N/A"}
                    size="small"
                    slotProps={{
                        input: {readOnly: true},
                        inputLabel: {sx: {...theme.typography.caption}},
                        htmlInput: {sx: {...theme.typography.caption, bgcolor: theme.palette.neutral[100]}}
                    }}
                />
            </Grid>
            <Grid size={{xs: 4}}>
                <TextField
                    fullWidth
                    label={uiText.consignee.province}
                    value={consigneeData?.consignee_province || "N/A"}
                    size="small"
                    slotProps={{
                        input: {readOnly: true},
                        inputLabel: {sx: {...theme.typography.caption}},
                        htmlInput: {sx: {...theme.typography.caption, bgcolor: theme.palette.neutral[100]}}
                    }}
                />
            </Grid>
            <Grid size={{xs: 4}}>
                <TextField
                    fullWidth
                    label={uiText.consignee.postalCode}
                    value={consigneeData?.consignee_postal_code || "N/A"}
                    size="small"
                    slotProps={{
                        input: {readOnly: true},
                        inputLabel: {sx: {...theme.typography.caption}},
                        htmlInput: {sx: {...theme.typography.caption, bgcolor: theme.palette.neutral[100]}}
                    }}
                />
            </Grid>
            <Grid size={{xs: 4}}>
                <TextField
                    fullWidth
                    label={uiText.consignee.country}
                    value={consigneeData?.consignee_country || "N/A"}
                    size="small"
                    slotProps={{
                        input: {readOnly: true},
                        inputLabel: {sx: {...theme.typography.caption}},
                        htmlInput: {sx: {...theme.typography.caption, bgcolor: theme.palette.neutral[100]}}
                    }}
                />
            </Grid>
            <Grid size={{xs: 12}}>
                <Typography variant='body2' sx={{
                    fontWeight: theme.typography.h1.fontWeight
                }}>
                    {uiText.consignee.heading2}
                </Typography>
            </Grid>
            <Grid size={{xs: 4}}>
                <FormControl fullWidth>
                    <TextField
                        value={consigneeDetails?.appointmentDeliverDate}
                        fullWidth
                        type="date"
                        required
                        label={uiText.consignee.appointmentDeliverDate}
                        size='small'
                        onChange={handleAppointmentDeliverDate}
                        onKeyDown={(e) => {
                            if (e.key !== 'Tab') {
                                e.preventDefault();
                            }
                        }}
                        slotProps={{
                            inputLabel: {
                                sx: {...theme.typography.caption}
                            },
                            htmlInput: {
                                sx: {...theme.typography.caption},
                                min: dayjs().format('YYYY-MM-DD')
                            }
                        }}
                    />
                </FormControl>
            </Grid>
            <Grid size={{xs: 4}}>
                <FormControl fullWidth>
                    <TextField
                        value={consigneeDetails?.deliverLocationOpenTime}
                        fullWidth
                        type="time"
                        required
                        onChange={handleDeliverLocationOpenTime}
                        onKeyDown={(e) => {
                            if (e.key !== 'Tab') {
                                e.preventDefault();
                            }
                        }}
                        label={uiText.consignee.deliverLocationOpenTime}
                        size='small'
                        slotProps={{
                            inputLabel: {
                                sx: {...theme.typography.caption}
                            },
                            htmlInput: {
                                sx: {...theme.typography.caption}
                            }
                        }}
                    />
                </FormControl>
            </Grid>
            <Grid size={{xs: 4}}>
                <FormControl fullWidth>
                    <TextField
                        value={consigneeDetails?.deliverLocationCloseTime}
                        fullWidth
                        onChange={handleDeliverLocationCloseTime}
                        type="time"
                        required
                        label={uiText.consignee.deliverLocationCloseTime}
                        size='small'
                        onKeyDown={(e) => {
                            if (e.key !== 'Tab') {
                                e.preventDefault();
                            }
                        }}
                        slotProps={{
                            inputLabel: {
                                sx: {...theme.typography.caption}
                            },
                            htmlInput: {
                                sx: {...theme.typography.caption}
                            }
                        }}
                    />
                </FormControl>
            </Grid>
            <Grid size={{xs: 4}}>
                <FormControl fullWidth>
                    <TextField
                        value={consigneeDetails?.appointmentDeliverName}
                        fullWidth
                        variant='outlined'
                        onInput={handleAppointmentDeliverName}
                        required
                        label={uiText.consignee.appointmentDeliverName}
                        // onInput={handleBolNumber}
                        size='small'
                        slotProps={{
                            inputLabel: {
                                sx: {...theme.typography.caption}
                            },
                            htmlInput: {
                                sx: {...theme.typography.caption}
                            }
                        }}
                    />
                </FormControl>
            </Grid>
            <Grid size={{xs: 4}}>
                <FormControl fullWidth>
                    {/*<TextField*/}
                    {/*    value={consigneeDetails?.appointmentDeliverPhone}*/}
                    {/*    fullWidth*/}
                    {/*    variant='outlined'*/}
                    {/*    onInput={handleAppointmentDeliverPhone}*/}
                    {/*    required*/}
                    {/*    label={uiText.consignee.appointmentDeliverPhone}*/}
                    {/*    size='small'*/}
                    {/*    slotProps={{*/}
                    {/*        inputLabel: {*/}
                    {/*            sx: {...theme.typography.caption}*/}
                    {/*        },*/}
                    {/*        htmlInput: {*/}
                    {/*            sx: {...theme.typography.caption}*/}
                    {/*        }*/}
                    {/*    }}*/}
                    {/*    error={(validatedResult !== null) && (!isValidatePhone(consigneeDetails?.appointmentDeliverPhone))}*/}
                    {/*    helperText={(validatedResult !== null) && (!consigneeDetails?.appointmentDeliverPhone ? uiText.consignee.require : !isValidatePhone(consigneeDetails?.appointmentDeliverPhone) && uiText.consignee.invalid)}*/}
                    {/*/>*/}
                    <MuiTelInput
                        label={uiText.consignee.appointmentDeliverPhone}
                        value={consigneeDetails?.appointmentDeliverPhone}
                        onChange={handleAppointmentDeliverPhone}
                        fullWidth
                        defaultCountry='CA'
                        size='small'
                        variant="outlined"
                        sx={{
                            "& .MuiInputLabel-root.MuiInputLabel-shrink": {
                                transform: "translate(14px, -9px) scale(0.75) !important",
                                ...theme.typography.caption
                            },

                            "& .MuiOutlinedInput-notchedOutline legend": {
                                fontSize: "0.75rem",
                            },
                        }}
                        slotProps={{
                            inputLabel: {
                                shrink: true,
                                sx: {...theme.typography.caption}
                            },
                            htmlInput: {
                                sx: {...theme.typography.caption}
                            }
                        }}
                        error={(validatedResult !== null) && (!isValidatePhone(consigneeDetails?.appointmentDeliverPhone))}
                        helperText={(validatedResult !== null) && (!consigneeDetails?.appointmentDeliverPhone ? uiText.consignee.require : !isValidatePhone(consigneeDetails?.appointmentDeliverPhone) && uiText.consignee.invalid)}
                    />
                </FormControl>
            </Grid>
            {
                (
                    consigneeDetails?.appointmentDeliverDate !== originalConsigneeDetails?.appointmentDeliverDate ||
                    consigneeDetails?.deliverLocationOpenTime !== originalConsigneeDetails?.deliverLocationOpenTime ||
                    consigneeDetails?.deliverLocationCloseTime !== originalConsigneeDetails?.deliverLocationCloseTime ||
                    consigneeDetails?.appointmentDeliverName !== originalConsigneeDetails?.appointmentDeliverName ||
                    consigneeDetails?.appointmentDeliverPhone !== originalConsigneeDetails?.appointmentDeliverPhone
                ) &&
                <Grid size={{xs: 12}}>
                    <FlexBox justifyContent='flex-end'>
                        <Button
                            variant="contained"
                            size="small"
                            onClick={handleUpdate}
                        >
                            {uiText.consignee.button}
                        </Button>
                    </FlexBox>
                </Grid>
            }
        </Grid>
    )
}